// extracted by mini-css-extract-plugin
module.exports = {"video_player":"_3QsUf","videoPlayer":"_3QsUf","video_container":"_56DPK","videoContainer":"_56DPK"};